// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__359yz","location":"Header_location__uaduh"};